import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OverTimeImporter  {
    _originalTypeClassName = "zERP.BO.OverTimeImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OverTimeImporter.translate = translateService;
}
this.info = null;
this.OverTimeImporterKey = null;
this._key = this.OverTimeImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
info:any;
private _OverTimeImporterKey:any;
get OverTimeImporterKey(): any {
    return this._OverTimeImporterKey;
  }
set OverTimeImporterKey(value: any) {
    this._OverTimeImporterKey = value;
    this._key = value;
  }

static ParseStatus(status: any): any{if (CLMS.Framework.String.IsNullOrEmpty(status)) {return Domain.LeaveRequestStatus.Approved;}
return (status == "Δεν έχει υποβληθεί" ? Domain.LeaveRequestStatus.Temporary : ((status == "Υποβλήθηκε" ? Domain.LeaveRequestStatus.Pending : ((status == "Υπο Επεξεργασία" ? Domain.LeaveRequestStatus.Validating : ((status == "Απορρίφθηκε" ? Domain.LeaveRequestStatus.Rejected : ((status == "Ακυρώθηκε" ? Domain.LeaveRequestStatus.Cancelled : Domain.LeaveRequestStatus.Approved)))))))));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OverTimeImporterKey == null || $this.OverTimeImporterKey == 0;
            }


}